import { Injectable } from '@angular/core';
import { iconMap, IconName } from './icon-map';

@Injectable({ providedIn: 'root' })
export class IconRegistryService {
  private icons = new Map<IconName, string>();

  constructor() {
    Object.entries(iconMap).forEach(([name, svg]) => {
      this.icons.set(name as IconName, svg);
    });
  }

  getIcon(name: IconName): string | undefined {
    return this.icons.get(name);
  }
}
